<form [formGroup]="belastVerdragsTariefFg">
  <div>
    <snelstart-ui-number-form-control formControlName="bedragMetVerdragstoepassing"
                                      id="bedragMetVerdragstoepassing"
                                      label="Bedrag dividend verdragstarief"
                                      class="custom-input-250"
                                      align="right"
                                      prefix="€"
                                      [showAllDecimals]="false"
                                      (change)="saveForm()"
    >
    </snelstart-ui-number-form-control>
  </div>
  <div>
    <snelstart-ui-select-form-control formControlName="landCode"
                                      label="Verdragsland"
                                      [options]="optionsLandcodes"
                                      class="custom-input-250"
                                      (change)="this.saveForm()"
    >
    </snelstart-ui-select-form-control>
  </div>
  <div>
    <snelstart-ui-number-form-control label="Percentage belasting (in decimalen)"
                                      formControlName="verdragsPercentage"
                                      id="verdragsPercentage"
                                      class="custom-input-250"
                                      align="right"
                                      prefix="%"
                                      [showAllDecimals]="true"
                                      (change)="this.saveForm()"
    >
    </snelstart-ui-number-form-control>
  </div>
</form>
